import axios from 'axios';
import store from '@/store';
import endpointVersion from '@/helpers/endpoint-version';
export const previewAudience = (payload) => {
    if (!payload.audienceId)
        return;
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'GET',
        baseURL: endpointVersion('v3'),
        url: `/audience/export`,
        validateStatus: () => true,
        params: {
            aid: payload.audienceId,
            brand: brand.id,
            columns: payload.columns ? payload.columns.toString() : '',
            preview: 1,
            orderby: payload.orderBy,
        },
    });
};
export const getColumnsList = () => {
    const user = store.getters.user;
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios.get('/audience/getExportColumnsList', {
        baseURL: endpointVersion('v3'),
        params: {
            brand: brand.id,
            locale: user?.language || 'pt-BR',
        },
        headers: { Authorization: `Bearer ${tokenV3}` },
    });
};
export const exportAudience = (audienceId, columns) => {
    const tokenV3 = store.state.auth.tokenV3;
    const brand = store.getters.selectedBrand;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'GET',
        baseURL: endpointVersion('v3'),
        url: `/audience/export`,
        params: {
            aid: audienceId,
            brand: brand.id,
            columns: columns ? columns.toString() : '',
            format: 'csv',
        },
    });
};
export const getExportJobDetails = (batchId) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'GET',
        baseURL: endpointVersion('v3'),
        url: `/audience/getExportJobDetails`,
        params: {
            batchId,
            brand: brand.id,
        },
    });
};
export const cancelExportImportJob = (batchId) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios({
        headers: { Authorization: `Bearer ${tokenV3}` },
        method: 'POST',
        baseURL: endpointVersion('v3'),
        url: `/audience/cancelJob`,
        params: {
            batchId,
            brand: brand.id,
        },
    });
};
